export default function appTypes() {
    return {
        SET_ERROR_TRY_AGAIN: 'SET_ERROR_TRY_AGAIN',
    };
}
